<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import { SvelteDate } from "svelte/reactivity";
  import { DateHelper } from "$lib/utils/dateHelper";
  import { getConfigurationContext } from "$lib/elev8Api/configurationContext.svelte";

  let config = getConfigurationContext();
  let date = new SvelteDate();

  let dateInterval: ReturnType<typeof setInterval>;
  onMount(() => {
    dateInterval = setInterval(() => {
      date.setTime(DateHelper.nowWithServerOffset());
    }, 1000);
  });
  onDestroy(() => {
    clearInterval(dateInterval);
  });

  $effect(() => {
    DateHelper.updateServerOffset(config.timestamp);
  });

  let dateString = $derived(
    DateHelper.getFormattedDate(config.timezone, config.language, date)
  );
  let timeString = $derived(
    DateHelper.getFormattedTime(config.timezone, config.language, date)
  );
</script>

<div class="time">
  {timeString}
</div>
<div class="date">
  {dateString}
</div>
